import { render, staticRenderFns } from "./CommunityItem.vue?vue&type=template&id=e14a9778&scoped=true"
import script from "./CommunityItem.vue?vue&type=script&lang=js"
export * from "./CommunityItem.vue?vue&type=script&lang=js"
import style0 from "./CommunityItem.vue?vue&type=style&index=0&id=e14a9778&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e14a9778",
  null
  
)

export default component.exports